import { Component, OnInit , ViewChild } from '@angular/core';
import {Grid , GridSearchItem , ServiceSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {ServiceSubjectService} from '../../../Services//service-subject.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-service-subject-overview',
  templateUrl: './service-subject-overview.component.html',
  styleUrls: ['./service-subject-overview.component.scss']
})
export class ServiceSubjectOverviewComponent implements OnInit {

  public grid: Grid;
  public serviceSubjectId;
  public serviceSubjectName;
  @ViewChild('deleteModal', {static: false}) deleteModal = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public helper: Helper,
    private translateService: TranslateService,
    private broadcastService: BroadcastService,
    private serviceSubjectService: ServiceSubjectService
  ) { }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.service_subject.subject',
          prop: 'name',
          sortable: true,
          type: TextColumn.type,
          translate: true,

        },
        // <TextColumn>{
        //   name: 'doctrine.service_subject.solution',
        //   prop: 'solutions',
        //   type: TextColumn.type,
        //   sortable: true,
        //   translate: true,
        // },
        <TextColumn>{
          name: 'doctrine.service_subject.solution',
          prop: 'solutions',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          noTruncate: true,
          valueFormatter: (solutions: { name?: string }[]) => {
            if (!Array.isArray(solutions) || solutions.length === 0) {
              return '';
            }
            return solutions
              .map((s) => s?.name)
              .filter((name): name is string => !!name)
              .join(', ');
          }
        },
        <TextColumn>{
          name: 'doctrine.service_subject.status',
          prop: 'status',
          type: TextColumn.type,
          sortable: true,
          translate: true,
          valueFormatter: row => row ? this.translateService.instant('global.active') : this.translateService.instant('global.inactive')
        },
        <NumberColumn>{
          name: 'global.position',
          prop: 'position',
          sortable: true,
          type: NumberColumn.type,
          translate: true,
          change: (e, row) => {
            const position = {position: e.target.value};
            this.serviceSubjectService.setPosition(position, row.id).subscribe((res) => {
              this.broadcastService.broadcast('refreshGrid', 'getServiceSubjects');
            });
          },
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => this.router.navigateByUrl('/back-office/service/subject/' + row.id + '/show'),
              showCallback: row => row,
              btnClass: 'ripple light '
            },
            <ActionItem>{
              icon: 'fa fa-pencil fa-lg',
              tooltip: 'global.edit',
              onclick: row => this.router.navigateByUrl('back-office/service/subject/' + row.id + '/edit'),
              btnClass: 'ripple light ms-1'
            },
            <ActionItem>{
              icon: 'fa fa-remove fa-lg',
              tooltip: 'global.remove',
              onclick: row => {
                this.serviceSubjectId = row.id;
                this.serviceSubjectName = row.name.bold();
                this.deleteModal.show();
              },
              btnClass: 'ripple light ms-1'
            },
          ]
        }
      ],
      service: this.serviceSubjectService,
      rememberURL: this.router.url,
      method: 'getServiceSubjects',
      defaultSort: 'position',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'asc',
      showButton: true,
    };
  }

  public deleteServiceSubject() {
    this.serviceSubjectService.deleteServiceSubject(this.serviceSubjectId).subscribe((res) => {
      this.deleteModal.hide();
      this.broadcastService.broadcast('refreshGrid', 'getServiceSubjects');
    });
  }

  public goToArchive() {
    this.router.navigateByUrl('back-office/service/subject/archive');
  }

}
